import React from 'react';
import PropTypes from 'prop-types';

import { Link as ReactRouterLink } from 'react-router-dom';

import { AMPPaths } from '../../ampRoutes';
import If from '../../shared/If';

const isNormalLinkTagOrAmp = (href, toPath) =>
  !!(href || AMPPaths.includes(toPath));

const Link = ({ to, href, children, className, ...rest }) => {
  const toPath = to ? to.split('#')[0] : null;
  return (
    <If
      condition={isNormalLinkTagOrAmp(href, toPath)}
      ifRender={() => (
        <a href={to || href} {...rest} className={className}>
          {children}
        </a>
      )}
      elseRender={() => (
        <ReactRouterLink to={to} {...rest} className={className}>
          {children}
        </ReactRouterLink>
      )}
    />
  );
};

Link.defaultProps = {
  to: null,
  href: null,
  className: null,
};

Link.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  className: PropTypes.string,
};

export default Link;
